// consts
export const ALERTS_CONTAINER_ID = 'app-alerts-container';

export const ACCOUNT_LINKS = [
	{ name: 'Rewards', link: '/account/rewards' },
	{ name: 'Profile', link: '/account/profile' },
	// { name: 'Wallet', link: '/account/wallet' },
	{ name: 'Cards', link: '/account/cards' },
	{ name: 'Favorites', link: '/account/favorites' },
	{ name: 'Orders', link: '/account/orders' }
];

export const HeadingsInfo = [
	{
		path: 'menu',
		title: 'Menu',
		showBottomBorder: true
	},
	{
		path: 'cart',
		title: 'Cart',
		showBottomBorder: true
	},
	{
		path: 'scan',
		title: 'Scan',
		showBottomBorder: false
	},
	{
		path: 'orders',
		title: 'Online Orders',
		showBottomBorder: true
	},
	{
		path: 'favorites',
		title: 'Favorites',
		showBottomBorder: true
	},
	{
		path: 'account',
		title: 'Account',
		showBottomBorder: true
	},
	{
		path: 'rewards',
		title: 'Rewards',
		showBottomBorder: true
	},
	{
		path: 'profile',
		title: 'Profile',
		showBottomBorder: true
	},
	{
		path: 'pickup',
		title: 'Pickup',
		showBottomBorder: true
	},
	{
		path: 'payment-options',
		title: 'Payment Options',
		showBottomBorder: true
	},
	{
		path: 'active',
		title: 'Order Information',
		showBottomBorder: true
	},
	{
		path: 'accessibility-statement',
		title: 'Accessibility Statement',
		showBottomBorder: true
	}
];

export const DRINK_GROUP_ID = [
	1, 2, 3, 4, 5, 9, 10, 11, 14, 15, 16, 21, 22, 23, 24, 25
];
